import InfoCardAvatarComponent from './InfoCardAvatarComponent';
export * from './InfoCardAvatarComponent';
export default InfoCardAvatarComponent;
